/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyDataAliases {
  CARD_0 = 'card-0',
  FETCH_0 = 'fetch-0',
  FIELD_1 = 'field-1',
  FORM_0 = 'form-0',
  LAYOUT_0 = 'layout-0',
  LINK_PRIVACY = 'link-privacy',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_3 = 'panel-3',
  PANEL_LAST_ACCESS = 'panel-last-access',
  PANEL_MY_DATA = 'panel-my-data',
  TEXT_0 = 'text-0',
  TEXT_LAST_ACCESS = 'text-last-access',
}
export { MyDataAliases };
